import React from 'react';
import { C } from './labs/wsShared';

const FONT = "'JetBrains Mono', monospace";

export default function KaggleDatasetPicker({ onClose, accentColor }) {
  const accent = accentColor || '#20beff';

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 220,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
        background: 'rgba(2,5,8,.84)',
        backdropFilter: 'blur(6px)',
      }}
    >
      <div
        onClick={(event) => event.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 520,
          borderRadius: 10,
          border: `1px solid ${accent}44`,
          background: 'linear-gradient(180deg, rgba(10,17,32,.98), rgba(2,5,8,.98))',
          boxShadow: '0 24px 80px rgba(0,0,0,.45)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 18px',
            borderBottom: `1px solid ${C?.b0 || '#1e293b'}`,
          }}
        >
          <div>
            <div style={{ fontSize: 9, letterSpacing: '.14em', color: accent, fontFamily: FONT, fontWeight: 800 }}>
              DATA CONNECTOR
            </div>
            <div style={{ marginTop: 6, fontSize: 18, fontWeight: 800, color: C?.t1 || '#e2e8f0', fontFamily: 'Syne, sans-serif' }}>
              Kaggle is under construction
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              width: 34,
              height: 34,
              border: `1px solid ${C?.b0 || '#1e293b'}`,
              background: C?.deep || '#060b14',
              color: C?.t3 || '#475569',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            ✕
          </button>
        </div>

        <div style={{ padding: '22px 20px 20px' }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '6px 10px',
              borderRadius: 999,
              background: `${accent}18`,
              border: `1px solid ${accent}33`,
              color: accent,
              fontSize: 10,
              fontFamily: FONT,
              fontWeight: 700,
              letterSpacing: '.08em',
              marginBottom: 14,
            }}
          >
            COMING SOON
          </div>

          <p style={{ margin: 0, fontSize: 12, lineHeight: 1.8, color: C?.t2 || '#94a3b8' }}>
            Kaggle import is being rebuilt right now and is temporarily unavailable.
            Please use `Upload File`, `HuggingFace`, `From URL`, or the sample datasets for now.
          </p>

          <div
            style={{
              marginTop: 16,
              padding: '14px 16px',
              borderRadius: 6,
              background: C?.raised || '#0d1525',
              border: `1px solid ${C?.b0 || '#1e293b'}`,
              color: C?.t3 || '#475569',
              fontSize: 11,
              lineHeight: 1.7,
            }}
          >
            We’ll bring Kaggle back once the connector is stable enough for launch.
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '16px 20px',
            borderTop: `1px solid ${C?.b0 || '#1e293b'}`,
            background: C?.deep || '#060b14',
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: '10px 16px',
              border: `1px solid ${accent}44`,
              background: `${accent}14`,
              color: accent,
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: 10,
              fontFamily: FONT,
              fontWeight: 700,
              letterSpacing: '.1em',
            }}
          >
            OKAY
          </button>
        </div>
      </div>
    </div>
  );
}
